module.exports = __webpack_public_path__ + "img/markerStop.ee74fcaa.svg";